/* eslint-disable no-underscore-dangle */
import styled from 'styled-components';
import { useEffect, useId } from 'react';
import beTwMerge from '@/utils/beTwMerge';
import useMediaQuery from '@/hooks/useMediaQuery';

/* Styles for captions and button inside wistia video */
const Container = styled.div`
  /* TOP RIGHT SOUND BUTTON */

  div[data-handle='click-for-sound-backdrop'] * {
    font-size: 14px !important;
    font-weight: 500 !important;
    font-family: Avenir !important;
  }

  div[data-handle='click-for-sound-backdrop'] svg {
    width: 40px !important;
    height: 40px !important;
  }

  /* CAPTIONS */

  div[data-handle='captions'] * {
    font-size: 14px !important;
  }

  @media (min-width: 768px) {
    div[data-handle='captions'] * {
      font-size: 16px !important;
    }
  }

  .w-video-wrapper.w-css-reset video {
    object-fit: fill !important;
  }
`;

interface WistiaContainerProps {
  wistiaURL: string;
  className?: string;
}

const getWistiaID = (url: string) => {
  let videoID = '';
  try {
    const wistiaUrl = new URL(url);
    videoID = wistiaUrl.pathname.replace('/embed/iframe/', '').replace('/', '').replace(wistiaUrl.search, '');
  } catch (e) {
    console.warn('Cannot get wistia ID from URL', e);
  }
  return videoID;
};

function WistiaContainer({ wistiaURL, className = '' }: WistiaContainerProps) {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const containerId = useId();

  useEffect(() => {
    const WISTIA_EMBED_SCRIPT_ID = 'wistia-ev1-script';

    if (!document.querySelector(`#${WISTIA_EMBED_SCRIPT_ID}`)) {
      const wistiaScript = document.createElement('script');
      wistiaScript.id = WISTIA_EMBED_SCRIPT_ID;
      wistiaScript.type = 'text/javascript';
      wistiaScript.src = '//fast.wistia.com/assets/external/E-v1.js';
      wistiaScript.async = true;
      document.head.appendChild(wistiaScript);
    }
  }, []);

  useEffect(() => {
    try {
      const url = new URL(wistiaURL);
      const videoID = getWistiaID(wistiaURL);
      const options = {};
      url.searchParams.forEach((value, key) => {
        options[key] = value;
      });

      // @ts-ignore
      window._wq = window._wq || [];
      // @ts-ignore
      window._wq.push({
        id: videoID,
        options,
      });
    } catch (e) {
      console.warn('Cannot start wistia container', e);
    }
  }, [wistiaURL]);

  useEffect(() => {
    const video = window['Wistia']?.api(containerId);
    if (video?.options?.autoPlay) {
      setTimeout(() => {
        video.play();
      }, 2000);
    }
  }, [isDesktop, wistiaURL, containerId]);

  return (
    <Container
      id={containerId}
      className={beTwMerge(`wistia_embed wistia_async_${getWistiaID(wistiaURL!)}`, className)}
    />
  );
}

export default WistiaContainer;
